module.exports = __webpack_public_path__ + "img/no-signature.c5e3a2cd.svg";